import { showMessage } from "./message-helper";
import { logger } from "./tslog";

export async function callGetUserData(middletierToken: string): Promise<any> {
  const apiUrl = process.env.API_URL;
  try {
    const response = await fetch(`${apiUrl}/auth/powerpoint`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${middletierToken}`,
        "Cache-Control": "no-cache",
      },
    });

    return await response.json();
  } catch (err) {
    logger.error(err);
    showMessage(`Error from middle tier. \n${err.responseText || err.message}`);
    throw err;
  }
}
